// extracted by mini-css-extract-plugin
export var col = "CoachsCorner-module--col--0lGz2";
export var container = "CoachsCorner-module--container--cJKo8";
export var header = "CoachsCorner-module--header--2dNHf";
export var row = "CoachsCorner-module--row--bKAYP";
export var section = "CoachsCorner-module--section--2HBUw";
export var sectionBg = "CoachsCorner-module--section-bg--3dgG8";
export var subheadline = "CoachsCorner-module--subheadline--ISJy6";